export function hwChannelHandler ({ $store, responce }) {
  $store.dispatch('staffUser/setClientsOnline', responce.clientsOnline || [])
  $store.dispatch('staffUser/setHostessesOnline', responce.hostessOnline || [])
}
